/* Add the existing published deadline guide near garment buying controls. */
(function () {
  'use strict';
  // Shopify appends this footer link, but its legacy banner hook did not
  // reopen saved choices in testing. Use the documented native preferences API.
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const previousStatus = link.parentElement.querySelector('[data-oakdene-cookie-status]');
    if (previousStatus) previousStatus.textContent = '';
    Promise.resolve().then(function () {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Preferences not ready');
      return window.privacyBanner.showPreferences();
    }).catch(function () {
      let status = link.parentElement.querySelector('[data-oakdene-cookie-status]');
      if (!status) {
        status = document.createElement('span');
        status.setAttribute('role','status');
        status.setAttribute('data-oakdene-cookie-status','');
        link.parentElement.appendChild(status);
      }
      status.textContent = 'Cookie preferences are temporarily unavailable. Please reload this page and try again.';
    });
  }, true);
  // Reuse the published 3–7 working-day guide from existing collection FAQs.
  // Only the multi-size garment calculator receives this guidance.
  function addGarmentGuide() {
    document.querySelectorAll('#calculator').forEach(function (calculator) {
      if (calculator.querySelector('[data-oakdene-garment-guide]')) return;
      const quantity = calculator.querySelector('input[type="hidden"][data-cpc_isquantity="true"]');
      const colour = Array.from(calculator.querySelectorAll('textarea, input[type="text"]')).some(function (el) { return /chosen.*colou?r/i.test((el.name || '')+' '+(el.getAttribute('data-calcname') || '')); });
      const sizes = calculator.querySelectorAll('input[type="number"][data-calcname]');
      if (!quantity || !colour || sizes.length < 2) return;
      const guide = document.createElement('p');
      guide.className = 'oakdene-garment-lead-time';
      guide.setAttribute('data-oakdene-garment-guide','');
      guide.innerHTML = '<strong>Planning your deadline?</strong> Our published guide is 3–7 working days from proof approval. Garment availability can affect timing. <a href="/pages/contact">Contact us to confirm your deadline before ordering.</a>';
      const submit = calculator.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');
      if (submit) submit.parentNode.insertBefore(guide,submit);
      else calculator.appendChild(guide);
    });
  }
  let queued = false;
  const observer = new MutationObserver(function () { if (!queued) { queued=true; requestAnimationFrame(function () { queued=false; addGarmentGuide(); }); } });
  if (document.querySelector('product-info')) { addGarmentGuide(); observer.observe(document.querySelector('product-info'),{childList:true,subtree:true}); }
})();
